(() => {
  const config = window.SaludSubscriptionConfig;
  if (!config || config.refreshGiftInventory) return;

  let pendingRefresh = null;
  config.refreshGiftInventory = () => {
    if (pendingRefresh) return pendingRefresh;
    pendingRefresh = (async () => {
      const url = new URL(window.Shopify?.routes?.root || '/', window.location.origin);
      url.searchParams.set('view', 'gift-inventory');
      url.searchParams.set('_', Date.now());
      const response = await fetch(url, { cache: 'no-store' });
      if (!response.ok) throw new Error(config.giftSyncError);
      const inventory = await response.json();
      if (!inventory || Array.isArray(inventory) || typeof inventory !== 'object'
        || Object.values(inventory).some((gift) => !gift || typeof gift.available !== 'boolean')) {
        throw new Error(config.giftSyncError);
      }
      const changed = JSON.stringify(config.giftInventory) !== JSON.stringify(inventory);
      config.giftInventory = inventory;
      if (changed) document.dispatchEvent(new CustomEvent('subscription-gifts:change'));
    })().finally(() => { pendingRefresh = null; });
    return pendingRefresh;
  };

  const refresh = () => {
    if (!document.hidden) config.refreshGiftInventory().catch(() => {});
  };
  document.addEventListener('visibilitychange', refresh);
  window.addEventListener('pageshow', refresh);
  window.addEventListener('focus', refresh);
  window.setInterval(refresh, 30000);
})();
